import { useEffect, useState, useRef } from "react";

import { ethers } from "ethers";

import { createTheme, ThemeProvider, CssBaseline } from "@material-ui/core";

import COINS from "./constants/coins";
import * as chains from "./constants/chains";

import ConnectWalletPage from "./Components/connectWalletPage";
import ConnectNetworkPage from "./Components/connectNetworkPage";

import {
  getAccount,
  getFactory,
  getNetwork,
  getWeth,
} from "./ethereumFunctions";

const configs = require("./configs.json");

const theme_light = createTheme({
  typography: {
    fontFamily: ["Nunito"].join(","),
  },
  palette: {
    type: "light",
    primary: {
      main: configs.theme.light.primary.main,
      contrastText: configs.theme.light.primary.contrastText,
    },
    secondary: {
      main: configs.theme.light.secondary.main,
      contrastText: configs.theme.light.secondary.contrastText,
    },
    background: {
      paper: configs.theme.light.background.paper,
      default: configs.theme.light.background.default,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: "14px",
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },
});

const theme_dark = createTheme({
  typography: {
    fontFamily: ["Nunito"].join(","),
  },
  palette: {
    type: "dark",
    primary: {
      main: configs.theme.dark.primary.main,
      contrastText: configs.theme.dark.primary.contrastText,
    },
    secondary: {
      main: configs.theme.dark.secondary.main,
      contrastText: configs.theme.dark.secondary.contrastText,
    },
    background: {
      paper: configs.theme.dark.background.paper,
      default: configs.theme.dark.background.default,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: "14px",
        boxShadow: "none",
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },
});

const autoReconnectDelay = 5000;

const Web3Provider = (props) => {
  const configs = require("./configs.json");
  let isDarkMode = localStorage.getItem("dark-mode");
  const [darkMode, setDarkMode] = useState(
    isDarkMode ? JSON.parse(isDarkMode) : false
  );
  const [isConnected, setConnected] = useState(true);
  const [isNetworkTrue, setNetworkTrue] = useState(true);

  const setWebTitleFav = () => {
    const header = document.getElementById("main-title-web");
    const favicon = document.getElementById("fav-icon");
    header.innerText = configs.theme.title;
    favicon.href = configs.theme.favicon;
  };

  let network = Object.create({});
  network.provider = useRef(null);
  network.signer = useRef(null);
  network.account = useRef(null);
  network.coins = [];
  network.chainID = useRef(null);
  network.router = useRef(null);
  network.factory = useRef(null);
  network.stacking = "";
  network.wethAddress = useRef(null);
  network.withdraw = "";
  network.nftSharing = "";
  network.investContracts = [];
  const backgroundListener = useRef(null);
  async function setupConnection() {
    try {
      console.log("tronweb", window.tronWeb);
      console.log("lets go!");
      network.provider = new ethers.providers.Web3Provider(window.ethereum);
      network.signer = await network.provider.getSigner();
      await getAccount().then((result) => {
        network.account = result;
      });

      await getNetwork(network.provider).then(async (chainId) => {
        // Set chainID
        network.chainID = chainId;
        if (chains.networks.includes(chainId)) {
          // Get the router Contract Address
          network.router = chains.routerAddress.get(chainId);
          // Get stacking contract address
          network.stacking = chains.stackAddress.get(chainId);
          // Get withdraw contract address
          network.withdraw = chains.withdrawAddress.get(chainId);
          // Get Invesment contract address
          network.investContracts = chains.investContracts.get(chainId);
          // Get nft sharing contract address
          network.nftSharing = chains.nftSharingAddress.get(chainId);
          // Get default coins for network
          network.coins = COINS.get(chainId);
          // Get Weth address from router
          // if (chainId == 137) {
            await getWeth(network.router).then((wethAddress) => {
              network.wethAddress = wethAddress;
              // Set the value of the weth address in the default coins array
              network.coins[0].address = wethAddress;
            });
            await getFactory(network.router).then((factoryAddress) => {
              network.factory = factoryAddress;
            });
          // }

          // if (chainId == 56) {
          //   network.wethAddress = "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c";
          //   // Set the value of the weth address in the default coins array
          //   network.coins[0].address =
          //     "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c";
          // }
          setConnected(true);
          setNetworkTrue(true);
        } else {
          console.log("Wrong network mate.");
          setNetworkTrue(false);
          setConnected(true);
        }
      });
    } catch (e) {
      setConnected(false);
      setNetworkTrue(false);
      console.log(e);
    }
  }

  /**
   * Switch To Poligon Network
   */
  async function switchNetwork(chain) {
    try {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: chain.chainId }],
      });

      setupConnection();
    } catch (switchError) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        try {
          await window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [chain],
          });
          setupConnection();
        } catch (addError) {
          console.log("add error", addError);
        }
      }
      // handle other "switch" errors
      console.log("switch error", switchError);
    }
  }

  async function createListener() {
    return setInterval(async () => {
      // console.log("Heartbeat");
      try {
        // Check the account has not changed
        const account = await getAccount();
        if (account != network.account) {
          await setupConnection();
        }
        // const chainID = await getNetwork(network.provider);
        // if (chainID !== network.chainID){
        //   setConnected(false);
        //   await setupConnection();
        // }
      } catch (e) {
        setConnected(false);
        setNetworkTrue(false);
        await setupConnection();
      }
    }, 1000);
  }

  useEffect(async () => {
    // Initial setup
    console.log("Initial hook");
    setWebTitleFav();
    await setupConnection();
    window.ethereum.on("chainChanged", () => {
      window.location.reload();
    });
    console.log("network: ", network);

    // Start background listener
    if (backgroundListener.current != null) {
      clearInterval(backgroundListener.current);
    }
    const listener = createListener();
    backgroundListener.current = listener;
    return () => clearInterval(backgroundListener.current);
  });

  const renderNotConnected = () => {
    console.log("Rendering");
    return (
      <div>
        {" "}
        {!isConnected && !isNetworkTrue && <ConnectWalletPage />}
        {isConnected && !isNetworkTrue && (
          <ConnectNetworkPage
            darkMode={darkMode}
            switchNetwork={(chain) => switchNetwork(chain)}
          />
        )}{" "}
      </div>
    );
  };

  const selectedTheme = darkMode ? theme_dark : theme_light;
  const onChangeDarkMode = () => {
    localStorage.setItem("dark-mode", !darkMode);
    setDarkMode(!darkMode);
  };
  return (
    <>
      <ThemeProvider theme={selectedTheme}>
        <CssBaseline />{" "}
        {(!isConnected || !isNetworkTrue) && renderNotConnected()}{" "}
        {isConnected && isNetworkTrue && (
          <> {props.render(network, darkMode, onChangeDarkMode)} </>
        )}{" "}
      </ThemeProvider>{" "}
    </>
  );
};

export default Web3Provider;
